import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import Layout from "./components/Layout";
import DashboardPage from "./pages/DashboardPage";
import ProductsPage from "./pages/ProductsPage";
import ClientsPage from "./pages/ClientsPage";
import PricingPage from "./pages/PricingPage";
import VisitsPage from "./pages/VisitsPage";
import ReportsPage from "./pages/ReportsPage";
import StaffPage from "./pages/StaffPage";
import SettingsPage from "./pages/SettingsPage";
import BraceletPage from "./pages/BraceletPage";
import LockerMapPage from "./pages/LockerMapPage";
import TouchPOSPage from "./pages/TouchPOSPage";

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="text-stone-500 font-manrope">Cargando...</div>
      </div>
    );
  }
  if (user === false || user === null) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function RoleRoute({ allowed, children }) {
  const { user } = useAuth();
  if (!user || !allowed.includes(user.role)) return <Navigate to="/panel" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/panel" replace />} />
              <Route path="/panel" element={<DashboardPage />} />
              <Route path="/productos" element={<RoleRoute allowed={["admin"]}><ProductsPage /></RoleRoute>} />
              <Route path="/clientes" element={<RoleRoute allowed={["admin", "cajero"]}><ClientsPage /></RoleRoute>} />
              <Route path="/precios" element={<RoleRoute allowed={["admin"]}><PricingPage /></RoleRoute>} />
              <Route path="/visitas" element={<VisitsPage />} />
              <Route path="/reportes" element={<RoleRoute allowed={["admin", "cajero"]}><ReportsPage /></RoleRoute>} />
              <Route path="/personal" element={<RoleRoute allowed={["admin"]}><StaffPage /></RoleRoute>} />
              <Route path="/configuracion" element={<RoleRoute allowed={["admin"]}><SettingsPage /></RoleRoute>} />
              <Route path="/pulsera" element={<BraceletPage />} />
              <Route path="/lockers" element={<LockerMapPage />} />
              <Route path="/pos" element={<TouchPOSPage />} />
            </Route>
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
